import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { push } from "connected-react-router";

import { Card, Col, Row, Popover, Statistic } from "antd";
import { ExportOutlined } from "@ant-design/icons";

import LoadingPage from "../../components/LoadingPage";

import RobotTopPerformance from "../robot/RobotTopPerformance";
import RobotOperationHours from "../robot/RobotOperationHours";
import RobotScheduledEvents from "../robot/RobotScheduledEvents";
import AlarmStatistics from "../alarms/AlarmStatistics";
import GeoLocationMap from "./GeoLocationMap";
import Notifications from "./Notifications";

import Wrike from "../wrike/Wrike";

import {
  getTickets,
  getCustomStatuses,
  getUpcomingEvents,
} from "../wrike/wrikeSlice";

import {
  CUSTOMER_MAINTENANCE_WRIKE_ID,
  CUSTOMER_SUPPORT_WRIKE_ID,
  WRIKE_TASK_PARAMS,
  CARD_CONFIG_STYLE,
  ROUTER_PERFORMANCE_ROOT,
} from "../../libs/constants";

function Dashboard(props) {
  const { isCustomer } = props;

  const dispatch = useDispatch();

  const robots = useSelector((state) => state.robot.robots);
  const tickets = useSelector((state) => state.wrike.tasks);
  const events = useSelector((state) => state.wrike.events);

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    // if (!isCustomer) {
    //   dispatch(
    //     getTickets(
    //       `folders/${CUSTOMER_SUPPORT_WRIKE_ID}/tasks`,
    //       WRIKE_TASK_PARAMS
    //     )
    //   );
    //   dispatch(
    //     getUpcomingEvents(
    //       `folders/${CUSTOMER_MAINTENANCE_WRIKE_ID}/tasks`,
    //       WRIKE_TASK_PARAMS
    //     )
    //   );
    //   dispatch(getCustomStatuses());
    // }
  }, [dispatch]);

  if (!robots) {
    return <LoadingPage />;
  }

  if (isCustomer && robots.length === 1)
    dispatch(push(`/${robots[0].name}/analytics`));

  const handleSearch = () => {
    setSearchText(searchText);
  };

  const handlePerformanceDetail = () => {
    dispatch(push(ROUTER_PERFORMANCE_ROOT));
  };

  const filterSWR = () => {
    if (searchText === "") {
      return robots;
    } else {
      return robots
        .map((item) =>
          (item.name &&
            item.name
              .toString()
              .toLowerCase()
              .includes(searchText.toLowerCase())) ||
          (item.customer &&
            item.customer
              .toString()
              .toLowerCase()
              .includes(searchText.toLowerCase())) ||
          (item.company &&
            item.company
              .toString()
              .toLowerCase()
              .includes(searchText.toLowerCase())) ||
          (item.location &&
            item.location
              .toString()
              .toLowerCase()
              .includes(searchText.toLowerCase()))
            ? item
            : null
        )
        .filter((item) => item);
    }
  };

  return (
    <React.Fragment>
      <Notifications robots={robots} />

      <Row gutter={[4, 4]}>
        <Col span={8}>
          <Card {...CARD_CONFIG_STYLE} title="">
            <center>
              <Statistic
                className="Dash"
                title="Total Weld Time"
                value={'270,479'}
                valueStyle={{ fontSize: 45 }}
                // precision={2}
                // valueStyle={{ color: "#3f8600" }}
                // prefix={<ArrowUpOutlined />}
                suffix="minutes"
              />
            </center>
          </Card>
        </Col>
        <Col span={8}>
          <Card {...CARD_CONFIG_STYLE} title="">
            <center>
              <Statistic
                className="Dash"
                title="Total SWRs"
                value={robots.length}
                valueStyle={{ fontSize: 45 }}
                // precision={2}
                // valueStyle={{ color: "#3f8600" }}
                // prefix={<ArrowUpOutlined />}
                // suffix="%"
              />
            </center>
          </Card>
        </Col>
        <Col span={8}>
          <Card {...CARD_CONFIG_STYLE} title="">
            <center>
              <Statistic
                className="Dash"
                title="Total Joints Welded"
                value={"48,620"}
                // style={{ fontSize: 30 }}
                valueStyle={{ fontSize: 45 }}
                // precision={2}
                // valueStyle={{ color: "#3f8600" }}
                // prefix={<ArrowUpOutlined />}
                // suffix="%"
              />
            </center>
          </Card>
        </Col>
        <Col span={8}>
          <Card {...CARD_CONFIG_STYLE} title="">
            <center>
              <Statistic
                className="Dash"
                title="Best Monthly Weld Time"
                value={'7,576'}
                valueStyle={{ fontSize: 45 }}
                // precision={2}
                // valueStyle={{ color: "#3f8600" }}
                // prefix={<ArrowUpOutlined />}
                suffix="minutes"
              />
            </center>
          </Card>
        </Col>
        <Col span={8}>
          <Card {...CARD_CONFIG_STYLE} title="">
            <center>
              <Statistic
                className="Dash"
                title="Active SWRs"
                value={48}
                precision={0}
                valueStyle={{ fontSize: 45 }}
                // valueStyle={{ color: "#3f8600" }}
                // prefix={<ArrowUpOutlined />}
                // suffix="%"
              />
            </center>
          </Card>
        </Col>
        <Col span={8}>
          <Card {...CARD_CONFIG_STYLE} title="">
            <center>
              <Statistic
                className="Dash"
                title="Joints Welded Yesterday"
                value={"165"}
                valueStyle={{ fontSize: 45 }}
                // precision={2}
                // valueStyle={{ color: "#3f8600" }}
                // prefix={<ArrowUpOutlined />}
                // suffix="%"
              />
            </center>
          </Card>
        </Col>

        <Col span={24}>
          <GeoLocationMap
            {...CARD_CONFIG_STYLE}
            title="World Map"
            robots={robots}
          />
        </Col>

        {/* {!isCustomer && (
          <Col span={8}>
            <Card {...CARD_CONFIG_STYLE} title="Wrike Tasks">
              <Wrike tasks={tickets} />
            </Card>
            <Card {...CARD_CONFIG_STYLE} title="Upcoming Events">
              <RobotScheduledEvents events={events} />
            </Card>
          </Col>
        )} */}

        {/* <Col span={isCustomer ? 12 : 8}>
          <Card {...CARD_CONFIG_STYLE} title="Activity / Health">
            <AlarmStatistics robots={robots} />
          </Card>
        </Col>

        <Col span={isCustomer ? 12 : 8}>
          <Card
            {...CARD_CONFIG_STYLE}
            title={
              <Popover
                title={"Performance Details"}
                content={
                  <p>Please click to see overall SWRs' performance details</p>
                }
                placement="topLeft"
                trigger={"hover"}
              >
                <div
                  onClick={handlePerformanceDetail}
                  style={{ cursor: "pointer" }}
                >
                  Top Performing Unit
                </div>
              </Popover>
            }
            extra={
              <span
                onClick={handlePerformanceDetail}
                style={{ cursor: "pointer" }}
              >
                <ExportOutlined />
              </span>
            }
          >
            <RobotTopPerformance robots={robots} />
          </Card>
          <Card {...CARD_CONFIG_STYLE} title="Operating Hours">
            <RobotOperationHours />
          </Card>
        </Col> */}
      </Row>

      {/*
      <Row justify="left">
        {robots.map((robot) => {
          const ring = robot.space
            ? (parseInt(robot.space.used, 10) /
                parseInt(robot.space.total, 10)) *
              100
            : null;
          return (
            <Col xs={20} sm={26} md={20} lg={12} xl={8}>
              <Badge dot={ring > 75} offset={[0, 16]}>
                <RobotCard key={robot.id} {...robot}></RobotCard>
              </Badge>
            </Col>
          );
        })}
      </Row> */}
    </React.Fragment>
  );
}

export default Dashboard;
